<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12">
            <h2 v-if="!edit">Add Document</h2>
            <h2 v-else>Edit Document</h2>
        </v-col>
        <div>
            <v-col cols="6">
                <v-form ref="form" v-model="isValid">
                    <v-row>
                        <v-col cols="12" class="upload-file">
                            <v-btn v-if="!edit" rounded text color="primary" @click="triggerFileInput">
                                {{ t('patients::button.browse') }}
                            </v-btn>
                            <v-file-input
                                ref="fileInput"
                                v-model="document.file"
                                dense
                                outlined
                                rounded
                                accept=".pdf"
                                mandatory
                                class="file mt-0"
                                :disabled="edit"
                                :label="edit ? document.filename : 'Choose file'"
                                :prepend-icon="null"
                                :rules="!edit ? validationRules.file : []"
                            ></v-file-input>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                v-model="document.title"
                                class="pt-0"
                                dense
                                outlined
                                rounded
                                label="Document Title"
                                :rules="validationRules.title"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                v-model="document.section"
                                class="pt-0"
                                dense
                                outlined
                                rounded
                                label="Section"
                                :rules="validationRules.section"
                                :items="sections"
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template #activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="document.effective_date"
                                        label="Effective Date"
                                        readonly
                                        dense
                                        outlined
                                        rounded
                                        :rules="validationRules.effective_date"
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="document.effective_date"
                                    no-title
                                    scrollable
                                    @input="menu = false"
                                >
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <v-checkbox
                                v-model="document.visible"
                                class="pt-0"
                                dense
                                outlined
                                rounded
                                label="Is visible"
                            ></v-checkbox>
                        </v-col>

                        <v-col cols="12">
                            <v-btn rounded large class="mr-5" @click="backToList"> Cancel</v-btn>
                            <v-btn :disabled="!isValid" color="primary" rounded large class="mr-5" @click="save()">
                                <span v-if="!edit">{{ t('quality-control::button.submit') }}</span>
                                <span v-else>Save</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            menu: false,
            edit: false,
            document: {
                title: null,
                section: null,
                visible: true,
                file: null,
                filename: null,
                effective_date: null,
            },
            sections: [
                { text: 'User Manuals', value: 'user_manuals' },
                { text: 'Public Protocols', value: 'public_protocols' },
            ],
            isValid: false,
            validationRules: {
                title: [(v) => !!v || t('default::validation.field.title')],
                file: [(v) => !!v || t('default::validation.field.pdf_file')],
                section: [(v) => !!v || t('default::validation.field.section')],
                effective_date: [(v) => !!v || t('default::validation.field.effective_date')],
            },
        };
    },
    mounted() {
        this.edit = !!this.id;
        if (this.edit) {
            this.loadItem();
        }
    },
    methods: {
        loadItem() {
            console.log(this.id);
            axios
                .get(route('api.v1.documents.show', { document: this.id }))
                .then((response) => {
                    this.document = response.data.data;
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                });
        },
        backToList() {
            this.$root.goTo(route('documents.index'));
        },
        triggerFileInput() {
            this.$refs.fileInput.$refs.input.click();
        },
        save() {
            let data = null;

            if (!this.edit) {
                data = new FormData();
                data.append('file', this.document.file);
                data.append('section', this.document.section);
                data.append('title', this.document.title);
                data.append('visible', this.document.visible);
                data.append('effective_date', this.document.effective_date);
            } else {
                data = {
                    section: this.document.section,
                    title: this.document.title,
                    visible: this.document.visible,
                    effective_date: this.document.effective_date,
                };
            }

            let url = this.edit
                ? route('api.v1.documents.update', { document: this.id })
                : route('api.v1.documents.store');

            let method = this.edit ? 'put' : 'post';

            axios({
                method: method,
                url: url,
                data: data,
            })
                .then(() => {
                    this.$root.goTo(route('documents.index'));
                })
                .catch((error) => {
                    console.log(error.response.data);
                    this.$root.notify('error', error.response.data?.errors[0]?.errors[0]);
                });
        },
    },
};
</script>
